// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import less from 'less';
import 'swiper/css/swiper.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import i18n from './utils/lang/index.js';
import comJs from './utils/comJs/comJSIndex.JS'
import "@/utils/comCss/number3.css";
import '@/font/iconfont.css'
import VueSkeletonLoader from 'skeleton-loader-vue';

// VUEX STATE MANAGEMENT
import Vuex from 'vuex';
import store from "./vuex/store.js"

import VueCountryCode from "vue-country-code";


// global js
import "./assets/css/global.less"

// import './registerServiceWorker'
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;

//import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap/dist/js/bootstrap.bundle.min.js'

Vue.config.productionTip = false
Vue.prototype.comJs = comJs;
Vue.use(Vuex)
Vue.use(less)
Vue.use(ElementUI)
Vue.use(VueCountryCode);
Vue.component('vue-skeleton-loader', VueSkeletonLoader);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js